<section class="carousel">
    <a routerLink="/list">
        <img id="carousel-picture" class="carousel-active" src=""  (contextmenu)="onRightClick()">
    </a>
</section>